import { Theme } from '@mui/material/styles'

const muiToolbar = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        minHeight: '3.5rem !important'
      }
    }
  }
}

export default muiToolbar
